export default __webpack_public_path__ + "static/media/skething.63c9440d.jpg";